import React from 'react';
import './PreServicios.css';

const PreServicios = () => {
  return (
    <div className='tienda-container' style={{backgroundColor: '#EDEBEB'}}>
            <div className='home-tittles'>
                <h3>Horarios de trabajo</h3>
                <hr/>
            </div>
        <div>    
            <div className=''>
                <h4 style={{color: '#D70418', textAlign: 'center', margin: '0 0 5px 0', padding: '0'}}>Lunes a Viernes</h4>
                <p style={{textAlign: 'center', margin: '0 0 15px 0', padding: '0'}}>Mañana: 7:30 hs a 12:00 hs</p>
                <p style={{textAlign: 'center', margin: '0 0 5px 0', padding: '0'}}>Tarde: 13:30hs a 18:00hs</p>
            </div>
            <div className=''>
                <p style={{textAlign: 'center', margin: '0 0 5px 0', padding: '0', fontSize: '12px' }}>* Viernes por la tarde horario de cierre 17:00hs</p>
                <h4 style={{color: '#D70418', textAlign: 'center', margin: '0 0 5px 0', padding: '0'}}>Sábados</h4>
                <p style={{textAlign: 'center', margin: '0 0 15px 0', padding: '0'}}>Cerrado</p>
            </div>
        </div>
    </div>
  )
}

export default PreServicios;
